import i18next from '@/lib/i18next';
import { TEI_DEFAULT_LANGUAGE } from '@/lib/constants/teiLanguageMap';

// Studio's i18next ships only an English resource, so `$t()` cannot render
// the shortened placeholder in the language of a translated draft. This map
// keys the shortened placeholder by TEI language directly. See NGSSNATL-2062.
export function shortPlaceholderForLang(teiLang) {
  const map = {
    [TEI_DEFAULT_LANGUAGE]: i18next.t('Enter here'),
    spa: 'Escribe aquí',
  };
  return map[teiLang] || map[TEI_DEFAULT_LANGUAGE];
}

// Height of the Table GO's content box. Differs from TEI_CONTENT_HEIGHT (424),
// which the other four GO subtypes use. The print worksheet has to match it so
// content wraps identically and a drawing overlay lands in the same place.
export const TABLE_TEI_CONTENT_HEIGHT = 430;

export default shortPlaceholderForLang;
